import axios from 'axios'

const state = () => ({
  banners: []
})

const getters = {
  infoBanners: (state) => state.banners
}

const mutations = {
  setBanners(state, banners)
  {
    state.banners = banners
  }
}

const actions = {
  async fetchInfoBanners({ commit })
  {
    try
    {
      const { data } = await axios.get('info-banner')
      commit('setBanners', Array.isArray(data) ? data : [])
    }
    catch (e)
    {
      console.warn('Banner fetch failed', e)
      commit('setBanners', [])
    }
  }
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}
